{
  "en": {
    "folders": {
      "breadcrumb": {
        "contentCount": "{count} Content | {count} Contents",
        "overview": "Overview",
        "showPath": "Show folder path",
        "up": "One level up"
      },
      "buttons": {
        "back": "Back",
        "clearDiscarded": "Clear trash",
        "createFolder": "Create folder",
        "deleteFolder": "Move to trash",
        "moveFolder": "Move",
        "renameFolder": "Rename folder",
        "renameItem": "Rename"
      },
      "emptyTrashDialog": {
        "button": "Empty",
        "text": "This action cannot be undone. All content in the trash will be permanently deleted.",
        "title": "Empty trash permanently?"
      },
      "confirmDeleteDialog": {
        "button": "Yes, delete",
        "text": "Deleted content cannot be restored.",
        "title": "Permanently delete content"
      },
      "discarded": {
        "alert": {
          "text": "From worksheets to audio recordings - if you delete materials, they end up in the trash and are permanently removed <strong>after 30 days</strong>."
        },
        "hints": {
          "noItems": {
            "emptyTable": "There are currently no items in your trash."
          }
        },
        "subline": "Deleted materials and folders remain in the trash for <strong>30 days</strong>. You can restore them within this period; after that, they will be permanently removed."
      },
      "headings": {
        "discarded": "Trash",
        "search": "My Content Search",
        "searchResults": "{count} search results"
      },
      "hints": {
        "emptySubfolder": {
          "emptyTable": "There are currently no items in this folder.",
          "text": "You can easily move content from other folders into this folder or create new content and subfolders directly here.",
          "title": "This folder is empty"
        },
        "noItems": {
          "addContent": "Create new content",
          "emptyTable": "There are no items in your storage yet.",
          "text": "Organize all the content and materials you've created into folders and find them easily.",
          "title": "Your storage",
          "videoId": "1174735056",
          "videoTitle": "Tutorial: Organize Your Content"
        },
        "share": {
          "text": "Share teaching materials with colleagues and use theirs. Via Remix, you can copy, adapt and reuse existing materials.",
          "title": "Sharing is caring: Collaborate easily"
        }
      },
      "labels": {
        "foldersNew": "New folder"
      },
      "bulk": {
        "actionsDropdown": "Content ...",
        "clearSelection": "Clear selection",
        "modals": {
          "delete": {
            "description": "The selected content will be moved to the trash. You can restore content from your trash within 30 days.",
            "heading": "Move to trash",
            "singleItemDescription": "You can restore content from your trash within 30 days.",
            "submit": "Yes, move to trash"
          },
          "move": {
            "heading": "Move content"
          }
        },
        "moveToFolder": "Move to folder",
        "selectedItems": "1 content selected | {count} contents selected",
        "undiscardItems": "Restore"
      },
      "filter": {
        "customRange": "Set time period",
        "dateFrom": "From",
        "dateTo": "To",
        "duration": "Time period",
        "items": "Material and Folder",
        "last30Days": "Last 30 days",
        "last7Days": "Last 7 days",
        "lastYear": "Last year ({ year })",
        "thisYear": "This year ({ year })",
        "totalPeriod": "Total period"
      },
      "links": {
        "trash": "Go to trash"
      },
      "modals": {
        "createFolder": {
          "heading": "Create folder"
        },
        "moveFolder": {
          "folder": "Folder",
          "moveToNewFolder": "Move into new folder",
          "newFolder": "New folder"
        },
        "renameFolder": {
          "heading": "Rename folder"
        }
      },
      "navbarTitle": "My content",
      "search": {
        "placeholder": "Search your content...‚"
      },
      "subtitle": "My Content",
      "title": "My content"
    }
  }
}
